var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCuisineDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "165px",
    height: "200px",
    viewBox: "0 0 165 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 33 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4109783,134.895815 C104.640163,134.895815 134.820978,104.715 134.820978,67.4853261 C134.820978,30.255163 104.639674,0.075326087 67.4109783,0.075326087 C30.1813043,0.075326087 0,30.255163 0,67.4853261 C0,104.715 30.1813043,134.895815 67.4109783,134.895815 Z",
    id: "path-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33-Copy-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF2F2",
    x: 0,
    y: 0,
    width: 165,
    height: 200,
    rx: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(6.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1889024,48.1698537 C60.5170136,5.76388922 105.650546,16.1204135 120.83223,31.7362861 C136.01369,47.3517237 141.684372,74.812452 124.222285,103.911486 C106.760637,133.010298 58.8872147,147.049426 35.9359829,122.088319 C23.5420808,108.60944 28.0111254,100.498895 35.7415415,89.2118767 L36.6132069,87.9442576 L36.6132069,87.9442576 L37.9619649,85.9881115 C44.0491962,77.1373623 51.2349002,66.1095718 53.9908239,49.4317718 L54.1889024,48.1698537 Z",
    id: "Path",
    fill: "#B82B27",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tj56y6yvha"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.909293,145.027174 C98.7133696,143.370489 68.6313587,113.453804 68.4425543,92.4603261 C68.43375,91.4805978 70.4969022,89.1225 70.4969022,89.1225 C73.6811413,85.95 79.8476087,85.95 80.8283152,84.7819565 C81.81,83.613913 79.6270109,82.3094022 78.1786957,82.3094022 C76.7303804,82.3094022 75.423913,82.8875543 73.3680978,84.0086413 C71.0325,84.0546196 68.9311957,84.7022283 67.37625,85.586087 C67.8829891,84.0247826 70.3036957,82.3094022 68.4596739,82.3094022 C66.0873913,82.3094022 65.2969565,83.4818478 64.3607609,85.2999457 C62.0452174,87.551413 62.0422826,82.1704891 60.9994565,82.3094022 C59.9566304,82.4483152 59.7027717,84.1079348 59.9820652,85.6452717 C60.1151087,86.3789674 59.6201087,86.778587 58.9397283,86.9008696 C58.7034783,86.3016848 58.4104891,85.5846196 58.0632065,84.7819565 C57.2267935,82.8474457 56.7533152,82.3094022 55.7598913,82.3094022 C54.9988043,82.3094022 54.8486413,82.717337 55.286413,84.266413 C55.5632609,85.2471196 55.7427717,85.4794565 56.5816304,87.4457609 C56.4720652,87.3616304 56.3517391,87.2721196 56.2182065,87.17625 C53.4482609,84.4811413 52.541413,82.3094022 51.2178261,82.3094022 C49.8873913,82.3094022 49.8277174,82.972663 50.9918478,84.1142935 C53.152337,86.2317391 52.4753804,87.1894565 53.6820652,89.0505978 C54.45,90.2342935 56.6427717,92.2822826 56.9333152,93.6626087 C64.0716848,127.5975 90.5625,209.360054 138.805435,169.843207 C121.33712,145.844511 108.909293,145.026685 108.909293,145.026685",
    id: "Path",
    fill: "#F5BA8F",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wd5mk9h2dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.555435,145.124022 C109.5525,145.124022 109.550543,145.123043 109.548098,145.122554 C109.411141,145.096141 109.294728,145.076576 109.201304,145.062391 C109.197391,145.062391 109.193967,145.061413 109.190543,145.060924 C109.147989,145.054565 109.109837,145.049185 109.077065,145.045272 L109.069239,145.044293 C109.035,145.039402 109.005652,145.035978 108.983152,145.033533 L108.977283,145.033533 L108.932283,145.028641 L108.9225,145.028152 L108.909293,145.026685 C108.761576,145.002717 108.608967,144.971413 108.452935,144.935707 C108.395707,144.9225 108.336522,144.906359 108.278315,144.891685 C108.179022,144.866739 108.07875,144.840815 107.976033,144.810978 C107.901196,144.789457 107.824402,144.765489 107.747609,144.741033 C107.660054,144.713641 107.572989,144.685761 107.483478,144.655435 C107.393967,144.62462 107.303967,144.593315 107.212011,144.559565 C107.136685,144.531685 107.059891,144.502337 106.98212,144.4725 C106.877446,144.431413 106.771793,144.390815 106.664185,144.345815 C106.609891,144.323804 106.553641,144.298859 106.498859,144.27587 C106.034185,144.077772 105.549946,143.84788 105.043696,143.58375 C92.6564674,137.111087 68.6108152,111.22288 68.4425543,92.459837 C68.43375,91.4805978 70.4969022,89.1225 70.4969022,89.1225 C73.6811413,85.95 79.8476087,85.95 80.8288043,84.7819565 C81.8095109,83.613913 79.6270109,82.3094022 78.1786957,82.3094022 C76.7308696,82.3094022 75.423913,82.8875543 73.3680978,84.0086413 C71.0325,84.0546196 68.9311957,84.7022283 67.37625,85.586087 C67.8834783,84.0247826 70.3036957,82.3094022 68.460163,82.3094022 C66.0878804,82.3094022 65.2964674,83.4818478 64.3602717,85.2999457 C62.0457065,87.5509239 62.0417935,82.1704891 60.9999457,82.3094022 C59.9571196,82.4483152 59.7022826,84.1074457 59.9815761,85.6452717 C60.1151087,86.3789674 59.6196196,86.778587 58.9397283,86.9013587 C58.7034783,86.3016848 58.4109783,85.5846196 58.0636957,84.7819565 C57.2267935,82.8469565 56.7533152,82.3094022 55.7598913,82.3094022 C54.9988043,82.3094022 54.8486413,82.717337 55.286413,84.266413 C55.56375,85.2471196 55.7422826,85.4789674 56.5816304,87.44625 C56.4720652,87.3616304 56.3522283,87.2721196 56.2182065,87.17625 C53.4482609,84.4811413 52.541413,82.3094022 51.2178261,82.3094022 C49.8873913,82.3094022 49.8277174,82.972663 50.992337,84.1142935 C53.152337,86.2317391 52.4753804,87.1894565 53.6825543,89.051087 C54.4495109,90.2342935 56.6427717,92.2822826 56.9333152,93.6626087 C57.0389674,94.1644565 57.1495109,94.6780435 57.2634783,95.2009239 C60.9520109,96.0143478 64.4644565,97.29 66.7897826,100.545163 C71.4345652,107.102446 73.8929348,113.659728 77.7184239,120.489457 C81.8163587,127.866522 86.4611413,134.696739 92.7445109,140.707663 C97.0425,144.779185 102.043859,147.911576 107.436033,150.148859 C109.284946,155.824728 110.343424,161.621413 108.59087,167.755598 C107.371467,172.190054 104.531576,175.14 100.9125,177.079891 C111.595598,182.651087 124.203913,181.803913 138.805435,169.843207 C123.662935,149.04 112.309728,145.656685 109.555435,145.124022",
    id: "Path",
    fill: "#D7905C",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b8wvxv5h4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.44375,44.9916848 C67.44375,46.4375543 66.2713043,47.6095109 64.8259239,47.6095109 C63.3800543,47.6095109 62.2080978,46.4375543 62.2080978,44.9916848 C62.2080978,43.5458152 63.3800543,42.3738587 64.8259239,42.3738587 C66.2713043,42.3738587 67.44375,43.5458152 67.44375,44.9916848",
    id: "Path",
    fill: "#FBF8DC",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "69dvxz1rfg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5077174,82.3094022 C27.5077174,61.6994022 44.216413,44.9916848 64.8259239,44.9916848 C85.4359239,44.9916848 102.14413,61.6994022 102.14413,82.3094022",
    id: "Path",
    fill: "#FBF8DC",
    fillRule: "nonzero",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p2erzjyh2i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.14413,82.3094022 C102.14413,72.0430435 97.9977717,62.7461413 91.2893478,55.9995652 C99.0792391,94.59 27.5082065,65.5728261 27.5082065,82.3098913 L102.14413,82.3098913 L102.14413,82.3094022 Z",
    id: "Path",
    fill: "#E8E3C7",
    fillRule: "nonzero",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n2lsbl92qk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.432065,83.9029891 L24.2197826,83.9029891 C23.3378804,83.9029891 22.62375,83.1883696 22.62375,82.3069565 C22.62375,81.4255435 23.3378804,80.7104348 24.2197826,80.7104348 L105.432065,80.7104348 C106.313478,80.7104348 107.028587,81.4255435 107.028587,82.3069565 C107.028587,83.1883696 106.313478,83.9029891 105.432065,83.9029891",
    id: "Path",
    fill: "#FFFDF5",
    fillRule: "nonzero",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "qvnjlsr74m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8576087,50.0688587 C87.1082609,51.3352174 84.8465217,51.0608152 82.6728261,51.9251087 C82.5955435,51.9559239 82.5231522,51.993587 82.4536957,52.035163 C83.1844565,50.9669022 81.6696196,49.0397283 81.18,46.3221196 C82.6640217,46.5030978 86.3941304,45.7698913 87.9417391,45.0753261 C86.1158152,47.144837 88.6069565,48.8025 87.8576087,50.0688587 M80.6791304,27.9772826 C82.0403804,29.4691304 83.8682609,31.717663 87.2633152,35.1004891 C84.4654891,33.180163 80.8566848,30.7961413 79.4044565,30.0345652 C77.0713043,28.8107609 75.2805978,30.0345652 77.2963043,31.6848913 C78.6893478,32.8245652 80.5230978,34.4817391 83.538587,36.8065761 C81.7028804,35.8449457 80.006087,34.9967935 79.1188043,34.6436413 C76.7592391,33.7020652 75.1128261,35.1053804 77.1965217,36.4998913 C78.87375,37.6224457 81.183913,39.367663 85.2857609,41.8382609 C82.8865761,42.0158152 78.2373913,42.8077174 77.763913,45.6163043 C77.3628261,47.9929891 80.3430978,53.3871196 81.9978261,52.4377174 C81.2523913,53.3929891 81.5717935,55.050163 83.6931522,54.4744565 C86.3031522,53.7657065 89.1195652,54.9146739 91.2066848,52.530163 C93.2942935,50.1456522 95.895,50.8490217 96.3880435,50.8632065 C110.709783,67.327337 121.853641,104.338859 117.558587,113.733098 C117.558587,113.733098 117.378587,114.044674 117.130598,114.696685 L146.106685,135.435815 C162.036196,108.245054 129.328043,60.1371196 103.789565,41.9678804 C81.1672826,25.8745109 82.9902717,26.6346196 82.9902717,26.6346196 C80.9241848,25.1559783 78.990163,26.1249457 80.6791304,27.9772826",
    id: "Shape",
    fill: "#F5BA8F",
    fillRule: "nonzero",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bvjk80p61o"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuisineDefault);
export default __webpack_public_path__ + "static/media/Cuisine-default.8165ada83311db810cd7c477caf8e1ef.svg";
export { ForwardRef as ReactComponent };